// extracted by mini-css-extract-plugin
export var md = "_29-4";
export var semantic = "_29-5";
export var sm = "_29-3";
export var text = "_29-6";
export var toggleInput = "_29-0";
export var toggleSwitch = "_29-1";
export var xs = "_29-2";